import * as S from "./style";
import SvgNoAccess from "../../../../../generated/images/NoAccess";
import { observer } from "mobx-react-lite";
import { Paragraph } from "@smartsuite/react-ui/lib";

export const ErrorSection = observer<{
  handleGoBack: () => void;
}>(({ handleGoBack }) => {
  return (
    <S.EmptyInputsStyled>
      <S.ErrorSectionWrapper>
        <SvgNoAccess data-testid="no-access-icon" />
        <S.ErrorTitle>You don’t have permissions</S.ErrorTitle>
        <S.ErrorText>
          Edits of the automation are restricted. Your permissions do not allow
          you to have access to this automation.
        </S.ErrorText>
        <S.BackButton onClick={handleGoBack}>Go Back</S.BackButton>
      </S.ErrorSectionWrapper>
    </S.EmptyInputsStyled>
  );
});

export const FieldMissingError = observer<{
  /** Translated error text; empty string hides the message. */
  message: string;
}>(({ message }) => {
  return message ? (
    <Paragraph color={"error"} size={"xs"}>
      {message}
    </Paragraph>
  ) : null;
});

export const ErrorMessage: React.FC<{
  message: string;
}> = ({ message }) => {
  return message ? (
    <Paragraph color={"error"} size={"xs"}>
      {String(message)}
    </Paragraph>
  ) : null;
};
